import { BOOKING_HREF, REVIEW } from '@/content/offer'
import { OAC } from '@/content/oac'
import { YOUTUBE_URL } from '@/shared/lib/constants'

/**
 * Server-rendered hero. Everything here is real DOM text — the <h1> is in the
 * initial HTML, which the previous scroll-driven laptop animation prevented.
 */
export function Hero() {
  return (
    <section className="bg-[#0e1110] px-4 pt-24 pb-20 md:pt-32 md:pb-28">
      {/* max-w-4xl matches PremiumSection's container so the hero and every
          section below it share one left edge. */}
      <div className="mx-auto max-w-4xl">
        <a
          href={YOUTUBE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mb-6 inline-flex items-center gap-2 font-mono text-sm text-[#8b958f] transition-colors hover:text-[#80cca5]"
        >
          <span className="inline-block size-1.5 rounded-full bg-[#80cca5]" />
          DarrenBuildsAI
        </a>

        <h1 className="mb-6 text-4xl font-semibold leading-[1.1] tracking-tight text-[#f0f3f1] md:text-6xl">
          The AI writes the code.
          <br />
          <span className="text-[#8b958f]">
            Keeping it maintainable is still your job.
          </span>
        </h1>

        <p className="mb-8 max-w-2xl text-lg leading-relaxed text-[#c3ccc7] md:text-xl">
          Claude Code, Cursor and OpenCode all work beautifully in a demo and
          then drift on your actual codebase. The problem is rarely the tool —
          it is how the tool is wired into your particular repo, and that is the
          part a video cannot reach.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row">
          <a
            href={BOOKING_HREF}
            className="inline-flex justify-center rounded-lg bg-[#80cca5] px-7 py-3.5 font-semibold text-[#0e1110] transition-colors hover:bg-[#6bb890]"
          >
            Book a Workflow Review — {REVIEW.price}
          </a>
          <a
            href={OAC.repoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex justify-center rounded-lg border border-[#2e3833] px-7 py-3.5 font-semibold text-[#f0f3f1] transition-colors hover:border-[#80cca5]/50 hover:text-[#80cca5]"
          >
            Or start with {OAC.short} — free
          </a>
        </div>

        <p className="mt-6 font-mono text-sm text-[#8b958f]">
          1:1 · {REVIEW.duration} · {REVIEW.capLine.toLowerCase()}
        </p>
      </div>
    </section>
  )
}
